"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var reactstrap_1 = require("reactstrap");
var immutability_helper_1 = require("immutability-helper");
var SpeisekarteModel_1 = require("../models/SpeisekarteModel");
var CustomDragItem_1 = require("./CustomPanel/CustomDragItem");
var Speise_1 = require("./Speise");
var NeueSpeise_1 = require("./CustomPanel/NeueSpeise");
var Additional_1 = require("./CustomPanel/Additional");
var NeuerKopf_1 = require("./CustomPanel/NeuerKopf");
var Kopfzeile = /** @class */ (function (_super) {
    __extends(Kopfzeile, _super);
    function Kopfzeile(props) {
        var _this = _super.call(this, props) || this;
        _this.SpeiseHandling = React.createRef();
        _this.KopfHandling = React.createRef();
        _this.newDish = function () {
            var newDish = new SpeisekarteModel_1.Dish();
            if (_this.props.smallHeadline.dishes !== null && _this.props.smallHeadline.dishes.length > 0)
                newDish.index = Math.max.apply(Math, __spreadArrays(_this.props.smallHeadline.dishes.map(function (o) { return o.index; }), [0])) + 1;
            else
                newDish.index = _this.props.smallHeadline.startIndex + 1;
            newDish.value = null;
            newDish.ingredients = null;
            newDish.price = null;
            newDish.weight = null;
            _this.SpeiseHandling.current.updateData(newDish, _this.props.smallHeadline.categorie);
        };
        _this.edit = function () {
            _this.KopfHandling.current.updateData(_this.props.smallHeadline);
        };
        _this.ConfirmedEvent = function (dish) {
            if (dish !== null) {
                var data = _this.props.smallHeadline;
                var dishIndex = data.dishes !== null ? data.dishes.length : 0;
                var newData = [];
                if (_this.props.smallHeadline.dishes !== null)
                    newData = immutability_helper_1.default(_this.props.smallHeadline.dishes, {
                        $splice: [[dishIndex, 1, dish]]
                    });
                else
                    newData.push(dish);
                var newArray = _this.props.smallHeadline;
                newArray.dishes = newData;
                _this.props.reorderEvent(newArray);
            }
            _this.SpeiseHandling.current.closeDialog();
        };
        _this.DeleteEvent = function (dish) {
            var data = _this.props.smallHeadline;
            var dishIndex = data.dishes.findIndex(function (c) { return c.index === dish.index; });
            var newData = immutability_helper_1.default(_this.props.smallHeadline.dishes, {
                $splice: [[dishIndex, 1]]
            });
            var newArray = _this.props.smallHeadline;
            newArray.dishes = newData;
            _this.props.reorderEvent(newArray);
            _this.SpeiseHandling.current.closeDialog();
        };
        _this.ConfirmedHeadEvent = function (head) {
            if (head !== null)
                _this.props.reorderEvent(_this.props.smallHeadline);
            _this.KopfHandling.current.closeDialog();
        };
        _this.changeEvent = function (dish) {
            var data = _this.props.smallHeadline;
            var dishIndex = data.dishes.findIndex(function (c) { return c.index === dish.index; });
            var newData = immutability_helper_1.default(_this.props.smallHeadline.dishes, {
                $splice: [[dishIndex, 1, dish]]
            });
            var newArray = _this.props.smallHeadline;
            newArray.dishes = newData;
            _this.props.reorderEvent(newArray);
        };
        _this.moveItem = function (dragIndex, hoverIndex, id) {
            var dragItem = _this.props.smallHeadline.dishes.find(function (x) { return x.index === id; });
            var newArray = immutability_helper_1.default(_this.props.smallHeadline.dishes, {
                $splice: [
                    [dragIndex, 1],
                    [hoverIndex, 0, dragItem],
                ],
            });
            var data = _this.props.smallHeadline;
            data.dishes = newArray;
            _this.props.reorderEvent(data);
        };
        return _this;
    }
    Kopfzeile.prototype.render = function () {
        var _this = this;
        var theme = office_ui_fabric_react_1.Customizations.getSettings(["theme"]).theme;
        return (React.createElement(reactstrap_1.Container, null,
            React.createElement(reactstrap_1.Row, null, this.props.smallHeadline.value !== null &&
                React.createElement(reactstrap_1.Col, { style: { paddingLeft: "0px" } },
                    this.props.isAdmin &&
                        React.createElement("div", { style: { display: "flex" } },
                            React.createElement("div", { style: { fontSize: "22px", fontWeight: 600, color: theme.palette.themePrimary } }, this.props.smallHeadline.value),
                            this.props.smallHeadline.additionalValue !== null && this.props.smallHeadline.additionalValue !== "" &&
                                React.createElement("div", { style: { paddingInlineStart: "5px", fontSize: "15px", fontWeight: 600, color: "rgb(84 82 82 / 94%)", marginTop: "5px" } },
                                    "(",
                                    this.props.smallHeadline.additionalValue,
                                    ")"),
                            React.createElement("div", { style: { position: "absolute", display: "flex", right: "15px", fontSize: "20px", fontWeight: 600, color: theme.palette.themePrimary } },
                                React.createElement(office_ui_fabric_react_1.IconButton, { iconProps: { iconName: 'Add' }, title: "Neu", ariaLabel: "Neu", onClick: this.newDish }),
                                React.createElement(office_ui_fabric_react_1.IconButton, { iconProps: { iconName: 'Edit' }, title: "Bearbeiten", ariaLabel: "Bearbeiten", onClick: this.edit }))),
                    !this.props.isAdmin &&
                        React.createElement("div", { style: { display: "flex" } },
                            React.createElement("div", { style: { fontSize: "22px", fontWeight: 600, color: theme.palette.themePrimary } }, this.props.smallHeadline.value),
                            this.props.smallHeadline.additionalValue !== null && this.props.smallHeadline.additionalValue !== "" &&
                                React.createElement("div", { style: { paddingInlineStart: "5px", fontSize: "15px", fontWeight: 600, color: "rgb(84 82 82 / 94%)", marginTop: "5px" } },
                                    "(",
                                    this.props.smallHeadline.additionalValue,
                                    ")")))),
            this.props.smallHeadline.subText !== null && this.props.smallHeadline.subText !== "" &&
                React.createElement(reactstrap_1.Row, { style: { fontSize: "15px", fontWeight: 300, color: "rgb(84 82 82 / 94%)" } }, this.props.smallHeadline.subText),
            React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, null,
                    this.props.isAdmin && this.props.smallHeadline.dishes !== null && this.props.smallHeadline.dishes.map(function (dish, num) {
                        return React.createElement(CustomDragItem_1.default, { key: dish.index, id: dish.index, categorie: _this.props.smallHeadline.categorie, dish: dish, index: num, type: _this.props.smallHeadline.value, moveItem: _this.moveItem, deleteDishEvent: _this.DeleteEvent, changeEvent: _this.changeEvent, isAdmin: _this.props.isAdmin, additive: _this.props.additive });
                    }),
                    !this.props.isAdmin && this.props.smallHeadline.dishes !== null && this.props.smallHeadline.dishes.map(function (dish, num) {
                        return (React.createElement("div", { style: { width: "100%" } },
                            React.createElement(Speise_1.default, { index: num, dish: dish, categorie: _this.props.smallHeadline.categorie, key: dish.index, isAdmin: _this.props.isAdmin, additive: _this.props.additive })));
                    }))),
            this.props.smallHeadline.additionals !== null && this.props.smallHeadline.additionals.length > 0 &&
                React.createElement("div", { style: { backgroundColor: theme.palette.themePrimary, color: "white", padding: "10px" } },
                    React.createElement(reactstrap_1.Row, { style: { fontSize: "15px", fontWeight: 600 } },
                        React.createElement(reactstrap_1.Col, null,
                            React.createElement("div", { style: { width: "100%" } }, "Extras:"))),
                    React.createElement(reactstrap_1.Row, { style: { fontSize: "15px", fontWeight: 300 } },
                        React.createElement(reactstrap_1.Col, null, this.props.smallHeadline.additionals.map(function (additional, num) {
                            return (React.createElement("div", { style: { width: "100%" } },
                                React.createElement(Additional_1.default, { index: num + _this.props.index + 100000, additional: additional, key: num + _this.props.index + 1200000 })));
                        })))),
            React.createElement(NeueSpeise_1.default, { confirmedEvent: this.ConfirmedEvent, deleteDishEvent: this.DeleteEvent, ref: this.SpeiseHandling, data: this.props.additive }),
            React.createElement(NeuerKopf_1.default, { confirmedEvent: this.ConfirmedHeadEvent, ref: this.KopfHandling })));
    };
    return Kopfzeile;
}(React.Component));
exports.default = Kopfzeile;
//# sourceMappingURL=Kopfzeile.js.map